import { createSlice } from "@reduxjs/toolkit";
import {
  onGetProjectList,
  onAddProject,
  onUpdateProject,
  onDeleteProject,
} from './thunk';

export const initialState = {
  projectList: [],
  errors: {}
};

const ProjectsSlice = createSlice({
  name: 'Projects',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(onGetProjectList.fulfilled, (state: any, action: any) => {
      state.projectList = action.payload;
    });
    builder.addCase(onGetProjectList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddProject.fulfilled, (state: any, action: any) => {
      state.projectList.unshift(action.payload);
    });
    builder.addCase(onAddProject.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdateProject.fulfilled, (state: any, action: any) => {
      state.projectList = state.projectList.map((list: any) =>
        list.projectId === action.payload.projectId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdateProject.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onDeleteProject.fulfilled, (state: any, action: any) => {
      state.projectList = state.projectList.filter(
        (productCategory: any) => productCategory.projectId.toString() !== action.payload.projectId.toString()
      );
    });
    builder.addCase(onDeleteProject.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
  }
});

export default ProjectsSlice.reducer;